import type { App } from 'vue';
import useFeature, { setupOptimizely } from './optimizely.js';

declare global {
    interface Window {
        optimizelyDatafile?: Record<string, unknown>;
    }
}

const VueOptimizely = {
    installed: false,

    install(app: App) {
        if (this.installed) {
            return;
        }

        this.installed = true;

        if (window.optimizelyDatafile) {
            setupOptimizely(window.optimizelyDatafile);
        }

        app.config.globalProperties.$feature = useFeature;
        app.provide('$feature', useFeature);
    },
};

export default VueOptimizely;
